import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomerSimplifiedDTO from "features/customer/dtos/CustomerSimplifiedDTO";
import React, { ReactElement } from "react";
import styles from "./profilecustomer.module.scss";
import { trackPromise } from "react-promise-tracker";
import { Shared_ProfileDialog } from "features/shared/components/loaders/promiseLoadingAreas";

interface IProps {
  customer: CustomerSimplifiedDTO;
  isActive: boolean;
  onCustomerClick: (customer: CustomerSimplifiedDTO) => Promise<void>;
}

const ProfileCustomer: React.FC<IProps> = (props) => {
  // props
  const { customer, isActive, onCustomerClick } = props;

  // HANDLERS
  const selectCustomerHandler = async () => {
    if (!isActive) {
      await trackPromise(onCustomerClick(customer), Shared_ProfileDialog);
    }
  };

  // helpers
  const getClass = (isActive: boolean) => {
    let activeClass = isActive ? ` ${styles.customerItemActive}` : "";
    return `${styles.customerItem}${activeClass}`;
  };

  // sub-renders
  const renderIcon = (isActive: boolean): ReactElement => {
    if (isActive) {
      return <FontAwesomeIcon icon="check" />;
    } else {
      return <FontAwesomeIcon icon="chevron-right" />;
    }
  };

  // render
  return (
    <div className={getClass(isActive)} onClick={selectCustomerHandler}>
      <div className="text-truncate">{customer.name}</div>
      <span className={styles.customerItemIcon}>{renderIcon(isActive)}</span>
    </div>
  );
};

export default ProfileCustomer;
